import { render, staticRenderFns } from "./TableTeste.vue?vue&type=template&id=70c5cf31&"
import script from "./TableTeste.vue?vue&type=script&lang=js&"
export * from "./TableTeste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports